import { render, staticRenderFns } from "./SettingBankList.vue?vue&type=template&id=b3212c84"
import script from "./SettingBankList.vue?vue&type=script&lang=js"
export * from "./SettingBankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports